<template>
    <occupants-find
        :params="{
            occupant: $route.params.occupant
        }"
        :include="[
            'note',
            'tenancies(include:property,residencies(paginate:1,5|include:occupant))'
        ]"
        v-slot="{
            has_loaded,
            is_loading,
            data: occupant,
            error,
            find
        }"
    >
        <div>
            <template v-if="!has_loaded">
                <base-loading
                    :retry="find"
                    :error="error"
                    class="py-6"
                />

                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </template>

            <template v-else>
                <div class="mb-6 rounded shadow id-details-card bg-grey-bg">
                    <header class="flex items-center px-4 bg-white border-b rounded-t h-18 sm:px-6">
                        <div class="flex-grow mr-3 overflow-hidden">
                            <h1 class="text-lg font-normal truncate">
                                {{ occupant.name }}
                            </h1>
                        </div>

                        <div
                            v-if="is_loading"
                            class="w-6 h-6 mr-3"
                        >
                            <base-svg
                                name="icon-loading"
                                class="w-full h-full"
                            />
                        </div>

                        <edit-dropdown
                            class="flex-none id-edit-dropdown"
                            :occupant="occupant"
                        />
                    </header>

                    <div class="px-4 py-3 sm:px-6 md:py-4">
                        <grid-layout class="-mt-3">
                            <grid-layout-item class="mt-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs tracking-wide uppercase text-grey-darker">Email</div>
                                <div class="text-sm">
                                    <template v-if="occupant.email">
                                        <a-mailto
                                            :email="occupant.email"
                                            class="text-blue"
                                        />
                                    </template>

                                    <base-na v-else />
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mt-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs tracking-wide uppercase text-grey-darker">Telephone</div>
                                <div class="text-sm">
                                    <template v-if="occupant.telephone">
                                        <a-tel
                                            :telephone="occupant.telephone"
                                            class="text-blue"
                                        />
                                    </template>

                                    <base-na v-else />
                                </div>
                            </grid-layout-item>
                        </grid-layout>
                    </div>
                </div>

                <notes-card
                    :note="occupant.note"
                    :notable="occupant"
                    class="mb-6"
                />

                <tenancies-card
                    :data="occupant.tenancies.data"
                    :meta="{
                        total: occupant.tenancies.data.length
                    }"
                    :can-new="true"
                    :new-to="{
                        name: $router.fix('dashboard.*.residencies.create'),
                        query: {
                            occupant: occupant.uuid
                        }
                    }"
                    class="mb-6 id-tenancies-card"
                >
                    <truncate-hack
                        slot="primary"
                        slot-scope="{ tenancy }"
                    >
                        <template v-if="$gate.role('landlord')">
                            <template v-if="tenancy.residencies && tenancy.residencies.meta.count > 0">
                                {{ tenancy.residencies.data | comma-delimited({
                                    callback: (residency) => residency.occupant.name,
                                    total: tenancy.residencies.meta.total
                                }) }}
                            </template>
                            <em
                                v-else
                                class="italic text-grey-darker"
                            >
                                No tenants
                            </em>
                        </template>
                        <template v-else>
                            {{ tenancy.property.landlord.name }}
                        </template>
                    </truncate-hack>
                </tenancies-card>
            </template>
        </div>
    </occupants-find>
</template>

<script>
    import EditDropdown from './show/edit-dropdown'
    import NotesCard from '../../../../components/notes-card'
    import OccupantsFind from '../../../../components/occupants-find'
    import TenanciesCard from '../../../../components/tenancies-card'

    export default {
        components: {
            EditDropdown,
            NotesCard,
            OccupantsFind,
            TenanciesCard
        }
    }
</script>
